module.exports = __webpack_public_path__ + "img/icon-opera.fdbb4d04.svg";